import React from 'react';
import ContactIntro from '../components/sections/ContactIntro';
import ContactChannels from '../components/sections/ContactChannels';
import ContactFormSection from '../components/sections/ContactFormSection';
import BlankSection from '../components/sections/BlankSection';

const Contact = () => {
  return (
    <>
      <ContactIntro />
      <ContactChannels hasBgColor topDivider />
      <ContactFormSection topDivider />
      <BlankSection />
    </>
  );
};

export default Contact;
